package com.milta.core.localization

data class ErrorStrings(
    val generic: String,
    val error: String,
    val fieldRequired: String,
    val invalidEmail: String,
    // Android picker (photo/PDF/spreadsheet) client-side size guard — see
    // ImportFilePickers.kt's MaxPickedFileSizeBytes. Deliberately not under ImportsStrings:
    // reused across all 3 pick entry points (photo/pdf/spreadsheet), not one screen's copy.
    val fileTooLarge: String,
)
